import React, { useState } from 'react'

import { IUploadQuotationProps } from '../client-request-cart/client-request-company-information/footer/owner-current-action/upload-quotation-modal/UploadQuotationModal'
import HostBasket from '../new-client-request-cart/components/ClientRequestCartOwner/HostBasket'
import { SuggestionViewEnum } from '../new-client-request-cart/enums/SuggestionViewEnum.enum'
import { AdminCanUpdateContextProvider } from '../../contexts/admin-can-update-context/AdminCanUpdateContextProvider'
import { ClientRequestCartHeader, ProposalProgressBar } from '../../organisms'
import { IProposalInteractionsProps } from '../../organisms/proposal/Proposal'
import { ClientRequestOutputDto } from '../../../lib/graphql'
import useDateFormatter from '../../../lib/hooks/useDateFormatter'

interface IClientRequestCartProps {
  clientRequest: ClientRequestOutputDto
  displayHeader?: boolean
  proposalInteractionProps?: IProposalInteractionsProps
  handleDepositPayment?: () => void
  canAdminUpdatePage?: boolean
  uploadQuotationData?: IUploadQuotationProps
  onPressOpenApp?: () => void
}

export const ClientRequestOwnerTemplate = ({
  displayHeader = false,
  clientRequest,
  proposalInteractionProps,
  canAdminUpdatePage,
  uploadQuotationData,
  onPressOpenApp,
}: IClientRequestCartProps) => {
  const dateFormatter = useDateFormatter()

  const [view, setView] = useState<SuggestionViewEnum>(SuggestionViewEnum.LIST)
  const stepData = clientRequest.stepOwner!

  const briefTitle = (
    <div className='flex flex-1 justify-between gap-5'>
      <span>
        Demande n°{clientRequest?.readableId} |{' '}
        {clientRequest.clientProposal &&
          dateFormatter.formatDateRange({
            startDate: clientRequest.clientProposal?.startDate,
            endDate: clientRequest.clientProposal?.endDate,
            formatString: 'fullDate',
            useUTC: true,
          })}{' '}
        | {clientRequest?.clientProposal?.adults} voyageurs
      </span>
    </div>
  )

  const isBeforeDeposit: boolean =
    !clientRequest.clientProposal?.userPaidDepositAt &&
    !clientRequest.clientProposal?.adminSkippedDepositPaymentAt

  return (
    <AdminCanUpdateContextProvider adminCanUpdate={canAdminUpdatePage}>
      <div className='m-auto flex h-full w-full max-w-[var(--max-width)] flex-col gap-5'>
        {displayHeader ? (
          <ClientRequestCartHeader
            briefTitle={briefTitle ?? ''}
            stepData={stepData}
            houseBookingType={
              clientRequest.clientProposal?.houseBookingType ?? undefined
            }
            onPressOpenApp={onPressOpenApp}
            stepNumber={clientRequest?.stepUser?.stepNumber}
            admin={
              isBeforeDeposit
                ? clientRequest.adminSales
                : clientRequest.adminCsm
            }
            view={view}
            setView={setView}
            setIsParameterModalOpen={() => void 0}
          />
        ) : (
          <ProposalProgressBar
            stepData={stepData}
            clientProposal={clientRequest.selectedProposal ?? null}
          />
        )}
        <div className='flex gap-5'>
          <HostBasket
            clientRequest={clientRequest}
            ownerActions={proposalInteractionProps?.ownerActions}
            uploadQuotationData={uploadQuotationData}
          />
        </div>
      </div>
    </AdminCanUpdateContextProvider>
  )
}
